import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi } from '@/api/base'

export const PTO_HANDBOOK_DOCUMENT_FILE_TYPE_URL = `${PTO_URL}/document-file-type`

const errors = createBaseResponseErrors('тип файла документа', 'типов файлов документов')

export const PTOHandbookDocumentFileTypeApi = createBaseCRUDApi(PTO_HANDBOOK_DOCUMENT_FILE_TYPE_URL, errors)
